// eslint-disable-next-line no-restricted-imports
import I18n from 'I18n';
export function localeI18nText(message, locale) {
  // Can't use useLocaleContext hook here because this is used in useMemo/useEffect
  return I18n.text(message, {
    locale
  });
}